module.exports = __webpack_public_path__ + "img/ico-noincluido.0c760e27.svg";